import * as React from "react";
import { cn } from "@/lib/utils";

const surface = "border border-zinc-200 font-geist text-neutral-900";

export type DashboardCardVariant = "default" | "muted";

const variantBackground: Record<DashboardCardVariant, string> = {
  default: "bg-white",
  muted: "bg-zinc-50",
};

export type DashboardCardProps = React.ComponentProps<"div"> & {
  variant?: DashboardCardVariant;
};

export const DashboardCard = React.forwardRef<
  HTMLDivElement,
  DashboardCardProps
>(({ className, variant = "default", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex min-w-0 flex-col rounded-2xl",
      surface,
      variantBackground[variant],
      className,
    )}
    {...props}
  />
));
DashboardCard.displayName = "DashboardCard";

export function dashboardNestedCardClassName(className?: string) {
  return cn(
    "flex min-w-0 rounded-xl border border-zinc-200 bg-white font-geist text-neutral-900 shadow-sm",
    className,
  );
}
